import { render } from "./header_scroll.svg?vue&type=template&id=58308a40"
const script = {}
script.render = render

export default script